import {
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Avatar,
} from '@material-ui/core';
import LoadingTableRow from 'components/LoadingTableRow';
import { ConversionsTablePropsType } from './types';
import { useTableStyles, useStylesTooltip } from './styles';

export default function ConversionsTable({ isLoading, data }: ConversionsTablePropsType) {
  const classes = useTableStyles();
  const tooltipClasses = useStylesTooltip();

  return (
    <Paper variant="outlined" className={classes.root}>
      <Typography variant="subtitle2" color="primary" className={classes.title}>
        Latest Conversions
      </Typography>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Advertiser</TableCell>
              <TableCell>Source</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Commission</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <LoadingTableRow rows={10} cells={4} />
            ) : data && data.length ? (
              data.map((row, idx) => (
                <TableRow
                  key={row.conversion.conversionClickUuid}
                  className={idx % 2 ? classes.tableRowAlt : classes.tableRow}
                >
                  <TableCell className={classes.tableCell}>
                    <div className={classes.avatarContainer}>
                      <Avatar
                        className={classes.avatar}
                        sizes="15"
                        alt={row.advertiser.advertiserUrl}
                        src={row.advertiser.advertiserFavicon}
                      >
                        {row.advertiser.advertiserUrl.charAt(0).toLowerCase()}
                      </Avatar>
                      <Tooltip title={row.advertiser.advertiserUrl} classes={tooltipClasses} arrow>
                        <div className={classes.text} style={{ width: '90px' }}>
                          {row.advertiser.advertiserUrl}
                        </div>
                      </Tooltip>
                    </div>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <Tooltip title={row.channel.channelUrl} classes={tooltipClasses} arrow>
                      <div className={classes.text} style={{ width: '90px' }}>
                        {row.channel.channelUrl}
                      </div>
                    </Tooltip>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <Tooltip title={row.conversion.conversionDatetime} classes={tooltipClasses} arrow>
                      <div className={classes.text} style={{ width: '90px' }}>
                        {row.conversion.conversionDatetime}
                      </div>
                    </Tooltip>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <Tooltip title={row.conversion.conversionCommission} classes={tooltipClasses} arrow>
                      <div className={classes.text} style={{ width: '90px' }}>
                        {row.conversion.conversionCurrencyCode} {row.conversion.conversionCommission}
                      </div>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} className={classes.tableCell}>
                  <Typography variant="subtitle1" className={classes.noData}>
                    No Conversions Found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
